import React from 'react';
import CSSModules from 'react-css-modules';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import Translate from '@client/components/shared/translation/Translate';

import styles from './styles.scss';

export const OpenReminder = (campaign) => (
    <a
        styleName="campaign-reminder"
        href={buildCampaignUrl(campaign.campaignIdentifier)}
    >
        <Translate message="campaigns.discover" />
    </a>
);

export default CSSModules(OpenReminder, styles);
